<template>
  <div class="tools-app-wrapper">
    <CgImportTemplate :entry="ToolsPath" :config="ToolsConfig" />
  </div>
</template>

<script>
import { Menu } from "ant-design-vue";

export default {
  name: "Tools",
  computed: {
    ToolsPath() {
      return this.$route.path.substring(1);
    },
    ToolsConfig() {
      return { Menu }
    }
  },
};
</script>

<style lang="less" scoped>
.tools-app-wrapper {
  height: 100%;
}
</style>
